// import React, { useContext } from "react";
// import { Button } from "@windmill/react-ui";
// //internal import
// import { SidebarContext } from "context/SidebarContext";
// const DrawerCancelNext = ({ handleNextStep }) => {
//   const { toggleDrawer,isDrawerOpen } = useContext(SidebarContext);
//   return (
//     <>
//       <div
//         className="fixed z-10 bottom-0 w-full right-0 py-4 lg:py-8 px-6 grid gap-4 lg:gap-6 xl:gap-6 md:flex xl:flex bg-gray-50 border-t border-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
//         style={{ right: !isDrawerOpen && -50 }}
//       >
//          <div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">
//           <Button
//             onClick={toggleDrawer}
//             className="h-12 bg-white w-full text-red-500 hover:bg-red-50 hover:border-red-100 hover:text-red-600 dark:bg-gray-700 dark:border-gray-700 dark:text-gray-500 dark:hover:bg-gray-800 dark:hover:text-red-700"
//             layout="outline"
//           >
//             Cancel
//           </Button>
//         </div>
//         <div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">
//               <Button
//               onClick={handleNextStep}
//               type="submit"
//               className="w-full h-12">
//               <span>Next</span>
//               </Button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DrawerCancelNext;
import React, { useContext, useState } from "react";
import { Button } from "@windmill/react-ui";
// Internal import
import { SidebarContext } from "context/SidebarContext";

const DrawerCancelNext = ({ handleNextStep }) => {
  const { toggleDrawer, isDrawerOpen } = useContext(SidebarContext);
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal

  const handleCancelClick = () => {
    setIsModalOpen(true); // Open the modal
  };

  const handleConfirmClose = () => {
    setIsModalOpen(false);
    toggleDrawer();
  };

  const handleCancelClose = () => {
    setIsModalOpen(false); // Close the modal without toggling the drawer
  };

  return (
    <>
      <div
        className="fixed z-10 bottom-0 w-full right-0 py-4 px-3 grid gap-4 lg:gap-6 xl:gap-6 md:flex xl:flex bg-gray-50 border-t border-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
        style={{ right: !isDrawerOpen && -50 }}
      >
        <div className="flex-1">
          <Button
            style={{ height: "2.5rem" }}
            onClick={handleCancelClick} // Trigger modal on cancel
            className="bg-white w-full text-red-500 hover:bg-red-50 hover:border-red-100 hover:text-red-600 dark:bg-gray-700 dark:border-gray-700 dark:text-gray-500 dark:hover:bg-gray-800 dark:hover:text-red-700"
            layout="outline"
          >
            Cancel
          </Button>
        </div>

        <div className="flex-1">
          <Button
            onClick={handleNextStep}
            type="submit"
            className="w-full h-10"
          >
            <span>Next</span>
          </Button>
        </div>
      </div>

      {/* Modal Box */}
      {isModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          style={{ animation: "fade-in 0.3s ease-out" }}
        >
          <div
            className="bg-white dark:bg-gray-600  p-6 rounded-lg shadow-xl max-w-sm mx-auto"
            style={{
              maxWidth: "400px",
              borderRadius: "12px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease-in-out",
              transform: "scale(1.05)",
              animation: "fade-in 0.3s ease-out",
            }}
          >
            <h2
              className="font-normal dark:text-gray-200 text-gray-600 mb-4 text-center text-lg"
              style={{
                marginBottom: "1rem",
                fontSize: "1.125rem",
              }}
            >
              Are you sure you want to close?
            </h2>

            <div className="flex justify-center items-center col-gap-10 mt-6">
              <span
                onClick={handleCancelClose}
                style={{
                  cursor: "pointer",
                  color: "#ef4444",
                  fontSize: "1.125rem",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              >
                No
              </span>

              <span
                onClick={handleConfirmClose}
                style={{
                  cursor: "pointer",
                  color: "#10B981",
                  fontSize: "1.125rem",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              >
                Yes
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DrawerCancelNext;
